import './styles/ID72.scss'

import {isBrowser} from "react-device-detect";

import {Link} from "react-router-dom";

import { TbRefresh } from 'react-icons/tb'
import { FaCheck } from 'react-icons/fa6'
import { FaRegLightbulb } from 'react-icons/fa6'
import { MdOutlineShield } from 'react-icons/md'
import { LiaBalanceScaleLeftSolid } from 'react-icons/lia'

import logoMini from '../../images/logo-mini-casplan.svg'
import xcllogo from '../../images/xcllogo.svg'


export const ID72 = () => {


    return (
        <div className={'id72'}>

            <header className={'header-casplan'}>
                <div className="header__header">
                    {/*<h1>*/}
                    {/*    <img src={logoMini} alt="" style={{height: '.8em'}}/>*/}
                    {/*</h1>*/}
                    <h3 style={{fontWeight: 200}}>
                        Современный продукт, обеспечивающий интегрированный подход к планированию. <br/> Уникальные
                        решения критически важных бизнес-функций: бюджетирование, коммерческое планирование, оптимизация
                        производства, управление цепочками поставок, планирование рабочей силы, аналитику и
                        прогнозирование.

                        <br/>

                        <Link to={'https://upr-uchet.kz/'}>Ссылка на основной сайт</Link>

                    </h3>
                </div>

                <div className="container">

                    <ul>
                        <li>
                            <div className="img-point"></div>
                            надёжность и мощность корпоративного класса
                        </li>
                        <li>
                            <div className="img-point"></div>
                            серверная установка или облачный SaaS
                        </li>
                        <li>
                            <div className="img-point"></div>
                            гибкость, сопоставимая с Excel
                        </li>
                    </ul>

                </div>
            </header>


            <div className="advantages__block">
                <h2>Преимущества</h2>
                <div className="advantages__container">
                    <div className="advantages-regular">
                        <div className="advantages-regular__item">
                            <h2>Гибкость</h2>
                            <p>Реализация самых сложных задач планирования</p>
                            <TbRefresh className="background-image background-image--left"
                                       style={{transform: 'rotate(25deg)'}}/>
                        </div>
                        <div className="advantages-regular__item">
                            <h2>Безопасность </h2>
                            <p>Надежность корпоративного уровня позволяет уйти из дорогих и небезопасных облаков,
                                установив сервера внутри компании.</p>

                            <MdOutlineShield className="background-image background-image--right"
                                             style={{transform: 'rotate(-25deg)'}}/>
                        </div>
                        <div className="advantages-regular__item">
                            <h2>Модели планирования</h2>
                            <p>Готовые к внедрению за 2 месяца и полностью кастомизированные.</p>
                            <FaRegLightbulb className="background-image background-image--left"
                                            style={{transform: 'rotate(25deg)'}}/>
                        </div>
                        <div className="advantages-regular__item">
                            <h2>Идеальный баланс</h2>
                            <p>Создан, чтобы заменить громоздкие и неудобные модели в MS Excel и негибкие традиционные
                                системы</p>
                            <LiaBalanceScaleLeftSolid className="background-image background-image--right"
                                                      style={{transform: 'rotate(-10deg)'}}/>
                        </div>
                    </div>
                    <div className="advantages-main">
                        <div className="advantages-main__text">
                            <h2>Конструктор функций</h2>
                            <p>
                                В зависимости от целевого пользователя платформа CasPlan предлагает готовый набор
                                шаблонов и функционала для разных отделов
                                предприятий.
                            </p>

                            <br/>
                            <br/>

                            <ul>
                                <li>
                                    <div className="img-point"></div>
                                    надёжность корпоративного класса
                                </li>
                                <li>
                                    <div className="img-point"></div>
                                    серверная установка или облачный SaaS
                                </li>
                                <li>
                                    <div className="img-point"></div>
                                    гибкость Excel
                                </li>
                            </ul>
                        </div>

                        <div className="advantages-main__images"></div>
                    </div>
                </div>
            </div>


            <div className="analogs-container">
                <h2>Сравнение с аналогами</h2>

                <div className="comparisons">
                    <div className="comparisons__item">
                        <div className="row">
                            <div></div>
                            <div><img src={logoMini} alt="" style={{ height: '2em', marginRight: '5px' }} /> CasPlan</div>
                            <div>
                                <img src={xcllogo} alt="" />
                            </div>
                        </div>
                        <div className="row">
                            <div className="row__item--text">Совместная одновременная работа пользователей</div>
                            <div>
                                <FaCheck />
                            </div>
                            <div>X</div>
                        </div>
                        <div className="row">
                            <div className="row__item--text">Разграничение прав доступа</div>
                            <div>
                                <FaCheck />
                            </div>
                            <div>X</div>
                        </div>
                        <div className="row">
                            <div className="row__item--text">Возможность автоматической интеграции</div>
                            <div>
                                <FaCheck />
                            </div>
                            <div>X</div>
                        </div>
                        <div className="row">
                            <div className="row__item--text">Совместная одновременная работа пользователей</div>
                            <div>
                                <FaCheck />
                            </div>
                            <div>X</div>
                        </div>
                    </div>
                    <div className="comparisons__item">
                        <div className="row">
                            <div></div>
                            <div><img src={logoMini} alt="" style={{ height: '2em', marginRight: '5px' }} />CasPlan</div>
                            <div style={{ fontSize: '12px', textAlign: 'center' }}>Традиционные системы планирования</div>
                        </div>
                        <div className="row">
                            <div className="row__item--text">Стоимость внедрения</div>
                            <div>низкие</div>
                            <div>высокие</div>
                        </div>
                        <div className="row">
                            <div className="row__item--text">Скорость внедрения</div>
                            <div>4-8 нед</div>
                            <div>9-12 мес</div>
                        </div>
                        <div className="row">
                            <div className="row__item--text">Требования к инфраструктуре клиента</div>
                            <div>низкие</div>
                            <div>высокие</div>
                        </div>
                        <div className="row">
                            <div className="row__item--text">Размер команды внедрения</div>
                            <div><FaCheck /></div>
                            <div>X</div>
                        </div>
                        <div className="row">
                            <div className="row__item--text">Self-service modelling</div>
                            <div><FaCheck /></div>
                            <div>X</div>
                        </div>
                    </div>
                </div>
                {/* <Review /> */}
            </div>

        </div>
    )
}